import React from 'react'
import Certificados from 'components/Certificados'

export default function CertificadosScreen () {
  return (
    <Certificados />
  )
}
